import { memo, useCallback } from 'react';

import { ListCardStyle } from 'types';
import { List } from 'components/list';
import { formatPrice } from 'utils/helpers';
import { isMobile, useNavigate } from 'hooks';
import { ListCard } from 'components/list-card';
import { formatCalendarDate } from 'utils/date';
import { ListHeader } from 'components/list-header';
import { Drawer, DrawerHeader } from 'components/drawer';
import { EventProfitAndLossLtlDetail } from 'store/api/event/types';

import { LtlDrawerProps } from './types';
import {
  titles,
  template,
  getLtlTotal,
  ltlSourceLabels,
  getLtlDetailsRoute,
} from './config';

const LtlCard = memo(
  ({
    value,
    onSelect,
  }: {
    value: EventProfitAndLossLtlDetail;
    onSelect: (value: EventProfitAndLossLtlDetail) => void;
  }) => {
    const handleClick = useCallback(() => onSelect(value), [value, onSelect]);

    return (
      <ListCard
        headers={titles}
        template={template}
        onClick={handleClick}
        values={[
          formatCalendarDate(value?.date),
          ltlSourceLabels[value?.source] ?? value?.source,
          value?.carrierName,
          value?.invoiceNumber,
          formatPrice(value?.amount),
        ]}
      />
    );
  }
);

export const LtlDrawer = memo(
  ({ opened, onClose, ltlDetails }: LtlDrawerProps) => {
    const mobile = isMobile();
    const navigate = useNavigate();

    const handleSelect = useCallback(
      (value: EventProfitAndLossLtlDetail) =>
        navigate(getLtlDetailsRoute(value)),
      [navigate]
    );

    if (!opened || !ltlDetails?.length) {
      return null;
    }

    return (
      <Drawer hideOverlay opened={true} topOffset={mobile ? '10%' : '15%'}>
        <DrawerHeader onClose={onClose} title="LTL Details" />
        <List
          count={ltlDetails.length}
          mainWrapperStyles={{ padding: 0 }}
          header={<ListHeader titles={titles} template={template} />}
          footer={
            <ListCard
              isOdd
              selected
              template={template}
              odd={ListCardStyle.Default}
              headers={['', '', '', '', 'Total Amount']}
              values={[
                'Total LTL',
                '',
                '',
                '',
                formatPrice(getLtlTotal(ltlDetails)),
              ]}
            />
          }
        >
          {ltlDetails.map((value) => (
            <LtlCard
              value={value}
              onSelect={handleSelect}
              key={`${value.source}-${value.id}`}
            />
          ))}
        </List>
      </Drawer>
    );
  }
);
